import type { BoxProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import type { SignupBanner } from 'types/cms/blocks/SignupBanner';

import { SIGN_UP_CTA_LABEL } from './constants';
import { CtaButton } from './CtaButton';
import { StickyCta } from './StickyCta';

interface SignupBannerCtasProps extends BoxProps {
  signupBanner: SignupBanner;
  colorScheme: 'white' | 'gray';
}

export function SignupBannerCtas({
  signupBanner,
  colorScheme,
  ...props
}: SignupBannerCtasProps) {
  const label = signupBanner.ctaTitle || SIGN_UP_CTA_LABEL;

  return (
    <Flex
      className="hero_signup-banner-ctas"
      direction="column"
      w="full"
      {...props}
    >
      <CtaButton
        anchorId={signupBanner._key}
        size="md"
        colorScheme={colorScheme}
      >
        {label}
      </CtaButton>
      <StickyCta
        type="anchor"
        anchorId={signupBanner._key}
        isSubscription={false}
        label={label}
      />
    </Flex>
  );
}
